export default __webpack_public_path__ + "static/media/grocery.1253f574.svg";